import { FieldRenderProps } from 'react-final-form';
import React, { ReactElement } from 'react';
import { Day } from '../../../network/api/types/compte/Day';
import { SimpleTime, timeSorter } from '../../../services/timeService';

type Props = FieldRenderProps<string> & {
  placeholder?: string
  selectSources: SimpleTime[]
  required?: boolean
  day: Day.DayOfWeekEnumType
  onChange: (time: string, name: string) => void
  value?: string
  disabled: boolean
};

type State = {
  focused: boolean
};

class TimeInput extends React.Component<Props, State> {
  state: State = {
    focused: false,
  };

  listRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

  toggleDropdown = (): void => {
    this.setState((prevState) => ({ focused: !prevState.focused }),
      () => {
        if (this.state.focused && this.listRef.current.children.namedItem(this.props.value)) {
          this.listRef.current.children.namedItem(this.props.value).scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
          });
        }
      });
  };

  blurInput = (): void => {
    this.setState({ focused: false });
  };

  render(): ReactElement {
    const htmlFor = this.props.input.name;
    return (
      <label
        htmlFor={htmlFor}
        className="time-input-container"
      >
        <input
          type="time"
          id={htmlFor}
          value={this.props.value}
          onChange={this.props.input.onChange}
          placeholder={this.props.placeholder || this.props.selectSources[0] ? `${this.props.selectSources[0].hours}:${this.props.selectSources[0].minutes}` : ''}
          required={this.props.required}
          readOnly
        />
        <button
          type="button"
          className="time-input-button"
          onBlur={this.blurInput}
          onClick={this.toggleDropdown}
          disabled={this.props.disabled}
        >
          {this.props.value || this.props.input.value || this.props.placeholder || `${this.props.selectSources[0].hours}:${this.props.selectSources[0].minutes}`}
        </button>
        <div ref={this.listRef} className="time-inputs-list">
          {
            this.state.focused && this.props.selectSources?.length && (
              this.props.selectSources.sort(timeSorter)
                .map((time) => {
                  const timeString = `${time.hours}:${time.minutes}`;
                  return (
                    <button
                      key={this.props.day + time.hours + time.minutes}
                      name={timeString}
                      type="button"
                      className={`time-item${this.props.value === timeString ? ' current' : ''}`}
                      onClick={(e) => {
                        this.props.input.onChange(timeString);
                        this.props.onChange(timeString, this.props.input.name);
                        this.blurInput();
                      }}
                      onMouseDown={(e) => e.preventDefault()}
                    >
                      {timeString}
                    </button>
                  );
                })
            )
          }
        </div>
      </label>
    );
  }
}

export default TimeInput;
